import { render, staticRenderFns } from "./About4.vue?vue&type=template&id=1328fd2d"
import script from "./About4.vue?vue&type=script&lang=js"
export * from "./About4.vue?vue&type=script&lang=js"
import style0 from "./About4.vue?vue&type=style&index=0&id=1328fd2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports